// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__q_b1c","boxTitle":"Qualiphy_boxTitle__1VjS7","box":"Qualiphy_box__2cbXv","toggleWrap":"Qualiphy_toggleWrap__22mSN"};